import { BlocklistPayload, BlocklistResult } from '@/types';
import { getParams } from '@/utils/params';
import { isAborted } from './methods/isAborted';
import { postRequest } from './methods/postRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchBlocklistCheck = (
  text: string,
  field: 'CYO_CUSTOM_TEXT' | 'SEARCH_TERMS' = 'CYO_CUSTOM_TEXT',
  signal?: AbortSignal
) => {
  const payload: BlocklistPayload = {
    candidates: [
      {
        field,
        text: text,
        userId: null,
      },
    ],
  };

  const url = `https://blocklist.spreadshirt.${
    getParams().platform === 'EU' ? 'net' : 'com'
  }/matchAgainstBlocklist`;
  return requestToJSON<BlocklistResult>(
    postRequest(url, payload, {
      headers: { 'Cache-Control': 'private, no-store' },
      signal,
    })
  ).catch((e) => {
    if (isAborted(e)) {
      return null;
    }
    throw e;
  });
};
